import ProductApi from '../../api/product'

const state = {
    iiko_catalogue: [],
}

const mutations = {
    storeIikoProducts (state, payload) {
        state.iiko_catalogue = payload
    }
}

const actions = {
    async getIikoCategoryProducts ({ commit }) {
        try {
            let { data } = ProductApi.getIikoCategoryProducts();
            commit('Product.storeIikoProducts', data);
        } catch (e) {

        }
    }
}

const getters = {
    getIikoCatalogue: state => state.iiko_catalogue,
}

export default {
    state,
    mutations,
    actions,
    getters
}
